import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useProperties } from '@/hooks/data/useProperties';
import { PropertiesTable } from './properties';

export const Route = createFileRoute('/_app/properties/leads')({
  component: PropertiesLeadsPage,
});

function PropertiesLeadsPage() {
  const { t } = useTranslation();
  const { data: leads = [], isLoading: loadingLeads, error: errLeads } = useProperties({
    marketingStage: 'lead',
  });
  const { data: aufnahme = [], isLoading: loadingA, error: errA } = useProperties({
    marketingStage: 'aufnahme',
  });
  const items = [...leads, ...aufnahme];

  return (
    <section className="space-y-6">
      <header>
        <h2 className="text-2xl font-semibold tracking-tight">
          {t('properties.leads.title', 'Immobilien — Leads & Aufnahme')}
        </h2>
        <p className="text-sm text-muted-foreground">
          {t(
            'properties.leads.subtitle',
            'Objekte in Lead- und Aufnahme-Phase, vor der aktiven Vermarktung.',
          )}
        </p>
      </header>
      <PropertiesTable
        items={items}
        loading={loadingLeads || loadingA}
        error={(errLeads as Error | null) ?? (errA as Error | null)}
      />
    </section>
  );
}
